export default __webpack_public_path__ + "static/media/page_under_construction.ffe36f7c.png";